import Vue from 'vue'

const luAgencyRole = {
  state: {
    luAgencyRoles: [],
    selectedLuAgencyRole: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luAgencyRoles(state) {
      return state.luAgencyRoles
    },
    selectedLuAgencyRole(state) {
      return state.selectedLuAgencyRole
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luAgencyRoles(state, payload) {
      state.luAgencyRoles = payload
    },
    selectedLuAgencyRole(state, payload) {
      state.selectedLuAgencyRole = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuAgencyRole(context, payload) {
      context.commit('selectedLuAgencyRole', payload)
    },
    loadLuAgencyRoles(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuAgencyRole'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luAgencyRoles', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedLuAgencyRole(context, payload) {
      if (
        context.state.selectedLuAgencyRole &&
        context.state.selectedLuAgencyRole.ID
      ) {
        context.dispatch(
          'loadSelectedLuAgencyRole',
          context.state.selectedLuAgencyRole.ID
        )
      }
    },
    loadSelectedLuAgencyRole(context, payload) {
      if (
        context.state.selectedLuAgencyRole &&
        context.state.selectedLuAgencyRole.ID != payload
      ) {
        context.commit('selectedLuAgencyRole', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuAgencyRole/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuAgencyRole', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadLuAgencyRoles(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLuAgencyRoles')
      })
    },
    updateLuAgencyRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuAgencyRole/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'agency role updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuAgencyRoles')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createLuAgencyRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuAgencyRole`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'agency role created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuAgencyRoles')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveLuAgencyRole(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuAgencyRole', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuAgencyRole', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuAgencyRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuAgencyRole/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'agency role deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuAgencyRoles')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default luAgencyRole
